module.exports = __webpack_public_path__ + "static/img/noData.52c68ab0.png";